import { IAccordionListProps } from 'modules/accordion-list';

export interface IXMLDynamicKeys {
	[key: string]: string;
}

export interface IXMLDecision {
	Onderwerp?: string;
	Samenvatting?: string;
}

export interface IXMLDecisions {
	Besluit?: IXMLDecision[];
}

export interface IXMLQuestion {
	Onderwerp?: string;
	Samenvatting?: string;
}

export interface IXMLQuestions {
	Rondvraag?: IXMLQuestion[] | IXMLQuestion;
}

export interface IXMLDecisionList {
	Titel?: string;
	Datum?: string;
	Besluiten?: IXMLDecisions;
	Rondvragen?: IXMLQuestions;
}

export interface IXmlData {
	Besluitenlijst?: IXMLDecisionList;
}

export const xmlPropsToHtmlDescription = (props: IXMLDynamicKeys): string => {
	const objectKeys = Object.keys(props);
	const showTable = objectKeys.length > 0;

	const rows = objectKeys.map((key) =>
		props[key] ? `<tr><td><p>${key}:</p></td><td><p>${props[key]}</p></td></tr>` : ''
	);
	const table = showTable ? `<table><tbody>${rows.join('')}</tbody></table>` : '';

	return table;
};

export const mapXmlToAccordionList = ({
	Titel,
	Datum,
	Besluiten,
	Rondvragen
}: IXMLDecisionList): IAccordionListProps => {
	const sections = [];

	const createQuestions = (questions: IXMLQuestion[] | IXMLQuestion) => {
		let questionArray;

		if (Array.isArray(questions)) {
			questionArray = questions.map(({ Onderwerp, ...rest }) => ({
				__typename: 'ComponentInternalAccordeonItem',
				itemTitle: Onderwerp,
				description: xmlPropsToHtmlDescription(rest as { [key: string]: string })
			}));
		} else {
			const { Onderwerp, ...rest } = questions;
			questionArray = [
				{
					__typename: 'ComponentInternalAccordeonItem',
					itemTitle: questions.Onderwerp,
					description: xmlPropsToHtmlDescription(rest as { [key: string]: string })
				}
			];
		}

		return questionArray;
	};

	if (Besluiten && Besluiten.Besluit) {
		sections.push({
			__typename: 'ComponentInternalAccordeonSection' as any,
			accordeonSectionName: Object.keys(Besluiten)[0],
			items: Besluiten?.Besluit?.map(({ Onderwerp, ...rest }) => ({
				__typename: 'ComponentInternalAccordeonItem',
				itemTitle: Onderwerp,
				description: xmlPropsToHtmlDescription(rest as { [key: string]: string })
			})) as any
		});
	}

	if (Rondvragen && Rondvragen.Rondvraag) {
		sections.push({
			__typename: 'ComponentInternalAccordeonSection' as any,
			accordeonSectionName: Object.keys(Rondvragen)[0],
			items: createQuestions(Rondvragen.Rondvraag)
		});
	}

	return {
		titel: Titel,
		datum: Datum,
		accordion: {
			__typename: 'ComponentModulesAccordeon',
			accordeonTitle: '',
			sections,
			defaultModuleOptions: { backgroundColor: 'white', padding: 'medium' }
		}
	};
};
